import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import classNames from 'classnames';
import ResizeObserver from 'resize-observer-polyfill';

import './Footer.scss';
import visa from '../../assets/images/footer/visa.png';
import mastercard from '../../assets/images/footer/mastercard.png';
import ipay from '../../assets/images/footer/ipay.png';
import maestro from '../../assets/images/footer/maestro.png';
import logo1 from '../../assets/images/footer/logo1.png';
import logo2 from '../../assets/images/footer/logo2.png';
import logo4 from '../../assets/images/footer/logo4.png';
import logo5 from '../../assets/images/footer/logo5.png';
import wcgLogo from '../../assets/images/footer/WCG_logo.png';
import responsibleLogo from '../../assets/images/footer/responsible-gambling.png';
import ficaLogo from '../../assets/images/footer/FICA_logo.png';
import ngbLogo from '../../assets/images/footer/NGB_logo.png';
import eighteenLogo from '../../assets/images/footer/18.png';
import AppModeContext from 'src/containers/AppMode/AppMode.context';
import Icon from '../Icon/Icon';
import RetailFooter from './RetailFooter/RetailFooter';

const WCG_URL = 'https://www.wcgrb.co.za';
const NGB_URL = 'https://www.ngb.org.za';
const EIGHTEEN_URL = 'https://www.wcgrb.co.za/wp-content/uploads/2019/08/GeneralRules.pdf';
const RESPONSIBLE_URL = 'https://responsiblegambling.org.za/';
const FICA_URL = 'https://www.fic.gov.za/Pages/Home.aspx';

class Footer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
      customerInfoHidden: true
    };

    this.modal = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', this.componentResized);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.componentResized);

    if (this.footer) {
      this.resizeObs.unobserve(this.footer);
    }
  }

  addRef = (el) => {
    this.footer = el;
    this.modal.current = el;
    if (this.footer) {
      this.resizeObs = new ResizeObserver(this.componentResized);
      this.resizeObs.observe(this.footer);
    }
  }

  componentResized = () => {
    this.setState({
      width: window.innerWidth
    });
  }

  onNextClick = async () => {
    this.props.resetBetslip();
    if (!_.isEmpty(this.props.customer)){
      this.props.logoutCustomer();
    }
  }

  handleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  buildList = (total, page, index) => {
    return (
      <li key={ index } className="footer__column-item">
        {
          page.link ?
            <a className="footer__link" href={ page.link } target="_blank" rel="noopener noreferrer">{ page.title }</a>
            :
            <Link
              className={
                classNames({
                  'footer__link': true,
                  'footer__link-clear': index + 1 === total
                })
              }
              to={ `/static/${ page.slug }` }
            >
              { page.title }
            </Link>
        }
      </li>
    );
  }

  buildColumn = (column, index) => {
    const { title, pages } = column;

    return (
      <li key={ index } className="footer__column">
        <ul>
          <li className="footer__column-title">{ title }</li>
          <div className="footer__column-inner-list">
            { pages.length > 0 && _.map(pages, (page, index) => this.buildList(pages.length, page, index)) }
          </div>
        </ul>
      </li>
    );
  }

  paymentMethods = () => {
    return (
      <div>
        <h4 className="footer__title">PAYMENT METHODS</h4>
        <div className="footer__payment-content">
          <div className="footer__payment">
            <img className="footer__img-logo" src={ visa } alt="visa" />
            <img className="footer__img-logo" src={ mastercard } alt="mastercard" />
            <img className="footer__img-logo" src={ ipay } alt="ipay" />
            <img className="footer__img-logo" src={ maestro } alt="maestro" />
          </div>
          <div className="footer__payment">
            <img className="footer__img-logo" src={ logo1 } alt="" />
            <img className="footer__img-logo" src={ logo2 } alt="" />
            <img className="footer__img-logo" src={ logo4 } alt="" />
            <img className="footer__img-logo" src={ logo5 } alt="" />
          </div>
        </div>
      </div>
    );
  }

  socialMedia = () => {
    const { configs } = this.props;

    return (
      <div className="footer__social">
        <h4 className="footer__title">SOCIAL MEDIA</h4>
        <div className="footer__social-content">
          <ul className="footer__social-networks__list">
            {
              !!configs['facebook'] && (
                <a href={ configs['facebook'] } target="_blank" rel="noopener noreferrer">
                  <Icon icon="facebook" />
                </a>
              )
            }
            {
              !!configs['twitter'] && (
                <a href={ configs['twitter'] } target="_blank" rel="noopener noreferrer">
                  <Icon icon="twitter" />
                </a>
              )
            }
          </ul>
          <span className="footer__version">
            { `Betsite - ${ JSON.parse(localStorage.getItem('sVersion'))?.r || '-' }` }
          </span>
          <span className="footer__version">
            { `Server - ${ JSON.parse(localStorage.getItem('sVersion'))?.n || '-' }` }
          </span>
        </div>
      </div>
    );
  }

  stickers = () => {
    return (
      <div className="footer__left footer--black">
        <div className="footer__img-container">
          <a href={ WCG_URL } target="_blank" rel="noopener noreferrer">
            <img className="footer__img-logo" src={ wcgLogo } alt="Western Cape Government Logo" />
          </a>
          <a href={ RESPONSIBLE_URL } target="_blank" rel="noopener noreferrer">
            <img className="footer__img-logo" src={ responsibleLogo } alt="National Responsible Gambling Logo" />
          </a>
        </div>
        <div className="footer__img-container">
          <a href={ FICA_URL } target="_blank" rel="noopener noreferrer">
            <img className="footer__img-logo" src={ ficaLogo } alt="Financial Intelligence Centre Logo" />
          </a>
          <a href={ NGB_URL } target="_blank" rel="noopener noreferrer">
            <img className="footer__img-logo" src={ ngbLogo } alt="National Responsible Gambling Board Logo" />
          </a>
        </div>
        <div className="footer__img-container">
          <a href={ EIGHTEEN_URL } target="_blank" rel="noopener noreferrer">
            <img className="footer__img-logo" src={ eighteenLogo } alt="18 plus" />
          </a>
        </div>
      </div>
    );
  }

  disclaimer = () => {
    return (
      <div className="footer__disclaimer">
        { /* eslint-disable max-len */ }
        <p>This Betsite is Powered by AIT&rsquo;s AETEQ Wagering Platform</p>
        <p>Copyright © 2014 Keith Ho Racing (Pty) Ltd | Advanced Internet Technologies (Pty) Ltd trading as BetXchange Western Cape is licenced with the Western Cape Gambling Board. <br /> Western Cape Gambling Board Licence No. 10180408-001 - 1st December 2022<br /> BetXchange Western Cape supports the National Responsible Gambling Programme.</p>
        <p>VAT Number: 4310270055 | REG Number: 2011/128781/07</p>
        <p>Keith Ho BetXchange Supports Responsible Gambling. For counselling, call the National Responsible Gambling Toll Free Helpline 0800 006 008.</p>
        <p>WINNERS KNOW WHEN TO STOP <br /> No persons under the age of 18 are permitted to gamble.</p>
        { /* eslint-enable max-len */ }
      </div>
    );
  }

  renderSiteFooter = () => {
    return (
      <>
        <div className="footer__top">
          <div className="footer__middle">
            <ul className="footer__list">
              { this.props.columns.length > 0 && _.map(this.props.columns, this.buildColumn) }
            </ul>
          </div>
        </div>

        {
          this.state.width > 1508 ?
            <div className="footer__bottom">
              { this.stickers() }
              <div className="footer__middle footer--black">
                { this.disclaimer() }
              </div>
              <div className="footer__payment-social">
                { this.paymentMethods() }
                { this.socialMedia() }
              </div>
            </div>
            :
            <div className="footer__bottom">
              <div className="footer__payment-social">
                { this.paymentMethods() }
                { this.socialMedia() }
              </div>
              { this.stickers() }
              { this.disclaimer() }
            </div>
        }
      </>
    );
  }

  renderTradingFooter = () => {
    const { t } = this.props;

    return (
      <div className="footer__bottom">
        <div className="footer__info">
          <span>{ t('footer.license') }:</span>
          <span>xxxx</span>
          <span>{ t('footer.company') }:</span>
          <span>xxxx</span>
          <span>{ t('footer.shop') }:</span>
          <span>xxxx</span>
          <span>{ t('footer.till') }:</span>
          <span>xxxx</span>
          <span>{ t('footer.user') }:</span>
          <span>xxxx</span>
        </div>
      </div>
    );
  }

  renderFooter = () => {
    if (this.context.RETAIL_MODE) {
      return <RetailFooter />;
    } else if (this.context.TRADING_MODE) {
      return this.renderTradingFooter();
    } else {
      return this.renderSiteFooter();
    }
  }

  render() {
    return (
      <footer
        className={
          classNames('footer', {
            'footer--sticky': this.context.RETAIL_MODE,
            'footer--trading': this.context.TRADING_MODE
          })
        }
        ref={ this.addRef }
      >
        { this.renderFooter() }
      </footer>
    );
  }
}

Footer.contextType = AppModeContext;

Footer.propTypes = {
  configs: PropTypes.object,
  columns: PropTypes.array,
  t: PropTypes.func,
  resetBetslip: PropTypes.func,
  logoutCustomer: PropTypes.func,
  history: PropTypes.object,
  location: PropTypes.object,
  customer: PropTypes.object,
  tillUser: PropTypes.string,
  selectedTimezone: PropTypes.string
};

const mapState = state => ({
  configs: state.content.configs,
  columns: state.content.template.footer.columns,
  customer: state.auth.customer,
  selectedTimezone: state.odds.selectedTimezone
});

export default connect(mapState, null)(withRouter(withTranslation('common')(Footer)));

